import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function NewTicket() {
  const useTicketsText = useGlotaT('spa.details.tickets.useTickets');
 
  return (
    <div>
      <p>
        {useTicketsText}
      </p>
    </div>
  );
}
export default NewTicket;
